import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=c2c84e50&scoped=true&"
import script from "./NotFound.js?vue&type=script&lang=js&"
export * from "./NotFound.js?vue&type=script&lang=js&"
import style0 from "./NotFound.scss?vue&type=style&index=0&id=c2c84e50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c84e50",
  null
  
)

export default component.exports